
import { OioButton, OioForm, OioFormItem, OioModal, OioPagination } from '@kunlun/vue-ui-antd';
import { computed, defineComponent, ref } from 'vue';
import { OioTable, OioColumn, TableSize } from '@kunlun/dependencies';

export default defineComponent({
  name: 'Action',
  components: {
    OioButton,
    OioForm,
    OioFormItem,
    OioModal,
    OioPagination,
    OioTable,
    OioColumn
  },
  inheritAttrs: false,
  props: [
    'action',
    'validateAndClick',
    'label',
    'visible',
    'openDialog',
    'doImport',
    'downloadTemplate',
    'options',
    'handleSelectChange',
    'workbookList',
    'selectValue',
    'validation1',
    'importLoading',
    'remove',
    'errorArr',
    'errorTableColums',
    'invisible'
  ],
  setup(props) {
    const showErrorModal = ref(false);
    const current = ref(1);
    const pageSize = ref(15);

    const viewList = computed(() => {
      const start = (current.value - 1) * pageSize.value;
      const end = start + pageSize.value;
      return props.errorArr.slice(start, end);
    });

    return {
      showErrorModal,
      current,
      pageSize,
      viewList,
      TableSize
    };
  }
});
